import { useState } from 'react';

import { ResidentValidateTransmitterResultType } from 'features/residents/models/resident-validate-transmitter-result-type';
import ValidateTransmitterResponse from 'features/residents/models/validate-transmitter-response';

export type LinkableTransmitterValidationPopupState = {
  validateTransmitterResponse: ValidateTransmitterResponse | null;
  handleValidationResult: (response: ValidateTransmitterResponse) => boolean;
  closeValidateTransmitterPopup: () => void;
};

const useLinkableTransmitterValidationPopupState = (): LinkableTransmitterValidationPopupState => {
  const [validateTransmitterResponse, setValidateTransmitterResponse] = useState<ValidateTransmitterResponse | null>(null);

  const handleValidationResult = (response: ValidateTransmitterResponse): boolean => {
    if (response.validationResultType === ResidentValidateTransmitterResultType.Valid) {
      setValidateTransmitterResponse(null);
      return true;
    }
    setValidateTransmitterResponse(response);
    return false;
  };

  const closeValidateTransmitterPopup = (): void => {
    setValidateTransmitterResponse(null);
  };

  return {
    validateTransmitterResponse,
    handleValidationResult,
    closeValidateTransmitterPopup,
  };
};

export default useLinkableTransmitterValidationPopupState;
